import { DotsLoader } from '@olxeu-jobs/ui';
import { Wrapper, TransparentLayer } from './styled-components';

type Props = {
  children: React.ReactNode;
  loading: boolean;
};

export const LoaderLayer: React.FC<Props> = ({ loading, children }) => (
  <Wrapper>
    {children}
    {loading && (
      <TransparentLayer>
        <DotsLoader />
      </TransparentLayer>
    )}
  </Wrapper>
);
